import script from "./auth-error.vue?vue&type=script&setup=true&lang=js"
export * from "./auth-error.vue?vue&type=script&setup=true&lang=js"

import "./auth-error.vue?vue&type=style&index=0&id=507bf1e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-507bf1e1"]])

export default __exports__